module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "goods",
    staticClass: "goods"
  }, [_c('img', {
    staticClass: "img",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "src": _vm.goods.src,
      "alt": _vm.goods.src
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('p', {
    staticClass: "title t-ellipsis"
  }, [_vm._v(_vm._s(_vm.goods.title))]), _vm._v(" "), _c('p', {
    staticClass: "desc t-ellipsis"
  }, [_vm._v(_vm._s(_vm.goods.desc))]), _vm._v(" "), _c('div', {
    staticClass: "last flex flex-between flex-cross-center"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goods.price))]), _vm._v(" "), _c('span', {
    staticClass: "link"
  }, [_vm._v("立即购买")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef59ba2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodItem.vue
// module id = 200
// module chunks = 5